
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'Instagram'
})
export default class Instagram extends Vue {}
